<script>
export default {
  name: 'CustomSelect',
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
 computed: {
    selectedOption() {
      return this.options.find((o) => o[this.valueName] === this.modelValue) || null;
    },
   optionsToSelect() {
      const options = [...this.options];

      if (this.useNull) {
        options.unshift({
          [this.valueName]: null,
          [this.labelName]: this.nullName,
        })
      }

      return options;
   }
  },

  data() {
    return {
      open: false,
    };
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      this.open = !this.open;
    },
    select(option) {
      this.$emit('update:modelValue', option[this.valueName]);
      this.open = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  props: {
    options: {
      type: Array,
      required: true,
      // формат [{ value: 1, label: "Option 1" }, ...]
    },
    modelValue: {
      type: [String, Number, Object, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Select...',
    },
    valueName: {
      type: String,
      default: 'value',
    },
    labelName: {
      type: String,
      default: 'label',
    },
    useNull: {
      type: Boolean,
      default: false,
    },
    nullName: {
      type: String,
      default: '[ Все ]'
    }
  },
};
</script>

<template>
  <div class="relative">
    <button @click="toggle" class="w-full p-2 flex justify-between items-center">
      <span class="text-sm" v-if="options.length">
        {{ selectedOption ? selectedOption[labelName] : placeholder }}
      </span>
      <span v-else class="text-sm italic">нет записей</span>
      <svg v-if="options.length"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 ml-2"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <ul
      v-if="open && options.length"
      class="border absolute z-10 mt-1 max-h-60 overflow-auto bg-gray-200 dark:bg-gray-800"
      style="width: max-content"
    >
      <li
        v-for="option in optionsToSelect"
        :key="option[valueName]"
        @click="select(option)"
        class="cursor-pointer p-2 text-sm hover:bg-gray-300 hover:dark:bg-gray-700"
      >
        {{ option[labelName] }}
      </li>
    </ul>
  </div>
</template>
